<div style="max-width: auto; overflow: auto">
  <div #passport></div>
  <app-common-list-table
    [request]="getRequest"
    [cols]="cols"
    [filtering]="filtering"
    [globalConditionalStyle]="globalConditionalStyle"
    [globalVisualTransform]="globalVisualTransform"
    [actionButtonText]="canAddTareas ? btnAnadir : ''"
    (emitSearchText)="updateFooter()"
    (actionButtonClick)="add()"
  >
    <ng-template #thEnd>
      <th>
        <p class="mb-0 d-flex justify-content-center">Acciones</p>
      </th>
    </ng-template>

    <ng-template #tdEnd let-data let-isFirstRow="isFirstRow">
      <td>
        <app-action-buttons
          [tourAnchorId]="isFirstRow ? 'farmerTour.rowActions' : ''"
          [hideDelete]="hiddenButtonDelete"
          [showDuplicate]="canDuplicateTareas"
          (duplicateRowButtonEvent)="duplicate(data)"
          (editRowButtonEvent)="edit(data)"
          (deleteRowButtonEvent)="show('delete', data)"
          (showRowButtonEvent)="show('info', data)"
        >
        </app-action-buttons>
      </td>
    </ng-template>

    <ng-template #header>
      <div style="margin-left: 20px;">
           <button class="mx-2 btn" (click)="uploadDialog()" style="padding: 5px; font-size: .8rem; background-color: #16A2B7; color: white">
              <i class="fa fa-upload"></i>
              Importar Maquinaria
          </button>
      </div>
  </ng-template>
  </app-common-list-table>
</div>


<app-modals
    [view]="this"
    [form]="form?.formFields"
    [serverUrl]="serverUrl"
    [previousData]="model"
    [recordHasAssociatedData]="false"
    [getRequest]="getRequest"
    [deleteRequest]="deleteRequest">
</app-modals>

<p-dialog width="600" header="Importar datos Calc" [closeOnEscape]="false" [closable]="false" [(visible)]="showImportar" (onShow)="scrollToTop()">

  <div *ngIf="showImportar" style="width: 36vw !important">

      <div>
          <p-fileUpload name="myfile[]" multiple="false" [showCancelButton]="false" chooseLabel="Seleccionar archivo" uploadLabel="Enviar" [url]="urlUpload" (onSelect)="checkFile($event)">
          </p-fileUpload>
      </div>

      <div >
          <br>
          <p style="max-width: 400px; text-align: center; color: red" [innerHTML]="importError"></p>
          <!-- <p style="max-width: 400px; text-align: center; color: green" [innerHTML]="importError"></p> -->

      </div>
      <br>
      <div class="d-flex justify-content-center">
          <button class="btn btn-dark mx-2" (click)="closeFUDialog();">Cerrar</button>
      </div>
      <br>
  </div>
</p-dialog>